import React from 'react';
import { PatternLibrary as PatternLibraryComponent } from '../components/PatternLibrary';

const PatternLibrary: React.FC = () => {
  return <PatternLibraryComponent />;
};

export default PatternLibrary;
